import React, { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { handlePostRequest } from '../../utils/api-handler.util'
import { showToaster } from '../../utils/show-toaster.util'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { useNavigate } from 'react-router-dom'

export default function CustomerSignUpForm({ data, onNext }) {
  const [formState, setFormState] = useState({
    name: '',
    phoneNumber: data?.phone || '',
    county: '',
    password: '',
    passwordConfirmation: '',
  })

  const navigate = useNavigate()

  const mutation = useMutation({
    mutationFn: (formData) => handlePostRequest('/customers/register', formData),
    onSuccess: (response) => {
      showToaster('success', 'Registration successful!')
      navigate('/login')
      if (onNext) onNext(response)
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.errorMessage
      throw new Error(errorMessage)
    },
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormState((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (formState.password !== formState.passwordConfirmation) {
      throw new Error('Passwords do not match')
    }

    const formData = {
      name: formState.name,
      phoneNumber: formState.phoneNumber,
      county: formState.county,
      password: formState.password,
      passwordConfirmation: formState.passwordConfirmation,
    }
    if (
      !formData.name ||
      !formData.password ||
      !formData.passwordConfirmation ||
      !formData.phoneNumber
    ) {
      throw new Error('Please fill in all required fields.')
    }

    try {
      await mutation.mutateAsync(formData)
    } catch (error) {
      showToaster('error', error.message)
    }
  }

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Enter Full Name <span className="text-red-600">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formState.name}
            onChange={handleChange}
            className="w-full bg-secondary-50 border-b border-black rounded px-3 py-2 text-lg"
            placeholder="Full Name"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Password <span className="text-red-600">*</span>
          </label>
          <input
            type="password"
            name="password"
            value={formState.password}
            onChange={handleChange}
            className="w-full bg-secondary-50 border-b border-black rounded px-3 py-2 text-lg"
            placeholder="Password"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Confirm Password <span className="text-red-600">*</span>
          </label>
          <input
            type="password"
            name="passwordConfirmation"
            value={formState.passwordConfirmation}
            onChange={handleChange}
            className="w-full bg-secondary-50 border-b border-black rounded px-3 py-2 text-lg"
            placeholder="Confirm Password"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full mt-4 py-3 bg-gradient-to-r from-[#DE8516] to-[#F08A0A] text-white font-semibold text-lg rounded-lg shadow"
        >
          REGISTER
        </button>
      </form>
    </div>
  )
}
